import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useFindHospitalUserLazy } from '@src/adapters/hooks/hospital/useFindHospitalUser';
import { useNavigationStore } from '@src/adapters/stores/useNavigationStore';
import { useParams } from 'react-router-dom';

export interface HospitalUserFormValues {
  firstName: string;
  lastName: string;
  roles: string[];
  gmcNumber: string;
  professionalBodyId: string;
}

export const EMPTY_HOSPITAL_USER_VALUES: HospitalUserFormValues = {
  firstName: '',
  lastName: '',
  roles: [],
  gmcNumber: '',
  professionalBodyId: '',
};

export function useHospitalUserForm() {
  const { userSlug = '' } = useParams<string>();
  const { currentHospital, currentOrganisation } = useNavigationStore();

  const [roles, setRoles] = useState<string[]>([]);
  const [fullName, setFullName] = useState<string>();

  const { execute: findHospitalUser } = useFindHospitalUserLazy();

  const form = useForm<HospitalUserFormValues>({
    defaultValues: EMPTY_HOSPITAL_USER_VALUES,
  });
  const { reset } = form;

  useEffect(() => {
    (async () => {
      const hospital = await findHospitalUser({
        userId: userSlug ?? '',
        hospitalId: currentHospital?.id ?? '',
      });
      reset({
        firstName: hospital.firstName ?? '',
        lastName: hospital.lastName ?? '',
        gmcNumber: hospital.registrationNumber ?? '',
        roles: hospital.roles ?? [],
        professionalBodyId: hospital.professionalBodyId,
      });

      setFullName(
        [hospital.firstName, hospital.lastName].filter(Boolean).join(' ')
      );

      setRoles(hospital.roles ?? []);
    })();
  }, [findHospitalUser, userSlug, reset, currentHospital?.id]);

  return {
    ...form,
    roles,
    setRoles,
    currentHospital,
    currentOrganisation,
    userSlug,
    fullName,
  };
}
